module.exports = __webpack_public_path__ + "img/平台架构.2bfca968.png";